import { render, staticRenderFns } from "./AppSupport.vue?vue&type=template&id=f3504966&scoped=true"
import script from "./AppSupport.vue?vue&type=script&lang=js"
export * from "./AppSupport.vue?vue&type=script&lang=js"
import style0 from "./AppSupport.vue?vue&type=style&index=0&id=f3504966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3504966",
  null
  
)

export default component.exports